module.exports = "/_next/static/images/98c3faf90fc228eb6dc10721391699fc-card-xs.png";